import React from 'react';
import styles from './Footer.module.css';
import Logo from '../../Assets/new-logo-white-1.png';
import { Link } from 'react-router-dom';
import '@fortawesome/fontawesome-free/css/all.min.css';

const quickLinks = [
  { label: 'Home', to: '/' },
  { label: 'About Us', to: '/about' },
  { label: 'Contact', to: '/contact' },
  { label: 'Blog', to: '/blog' },
];

const services = [
  { label: 'Digital Marketing', to: '/digital' },
  { label: 'OOH Media Planning', to: '/oohmedia' },
  { label: 'ATL Media Planning', to: '/atlmedia' },
  { label: 'BTL Media Planning', to: '/btlmedia' },
  { label: 'Transit Media', to: '/transitmedia' },
  { label: 'Event Management', to: '/event' },
  { label: 'Film Production', to: '/filmproduction' },
  { label: 'Corporate Gifting', to: '/corporategifting' },
];

const socials = [
  { icon: 'fab fa-facebook-f', href: 'https://www.facebook.com/yeskondomedia', label: 'Facebook', cls: styles.social_fb },
  { icon: 'fab fa-instagram', href: 'https://www.instagram.com/yeskondo_media_pvt_ltd_/', label: 'Instagram', cls: styles.social_ig },
  { icon: 'fab fa-linkedin-in', href: 'https://www.linkedin.com/company/yeskondo-media-pvt-ltd', label: 'LinkedIn', cls: styles.social_li },
  { icon: 'fab fa-twitter', href: 'https://x.com/yeskondomedia', label: 'Twitter/X', cls: styles.social_tw },
  { icon: 'fab fa-youtube', href: 'https://www.youtube.com', label: 'YouTube', cls: styles.social_yt },
];

const Footer = () => {
  return (
    <footer className={styles.footer} aria-label="Site Footer">

      {/* ── Top CTA Strip ── */}
      <div className={styles.cta_strip}>
        <div className={styles.cta_inner}>
          <div>
            <p className={styles.cta_eyebrow}>Ready to grow your brand?</p>
            <h2 className={styles.cta_heading}>Let's create something great together.</h2>
          </div>
          <div className={styles.cta_actions}>
            <Link to='/contact' className={styles.cta_btn_primary}>Start a Project</Link>
            <a href='tel:+919922966739' className={styles.cta_btn_secondary}>📞 Call Now</a>
          </div>
        </div>
      </div>

      {/* ── Main Footer Grid ── */}
      <div className={styles.footer_main}>
        <div className={styles.footer_grid}>

          {/* Col 1 — Brand */}
          <div className={styles.col_brand}>
            <img src={Logo} alt='Yeskondo Media Pvt Ltd Logo' className={styles.footer_logo} />
            <p className={styles.brand_desc}>
              Yeskondo Media Pvt. Ltd. — Pune's premier 360° marketing agency.
              We craft powerful campaigns across digital, OOH, ATL, BTL, events
              and beyond to make your brand unforgettable.
            </p>
            {/* Social icons */}
            <div className={styles.social_row}>
              {socials.map((s, i) => (
                <a
                  key={i}
                  href={s.href}
                  target='_blank'
                  rel='noreferrer'
                  aria-label={s.label}
                  className={`${styles.social_icon} ${s.cls}`}
                >
                  <i className={s.icon}></i>
                </a>
              ))}
            </div>
          </div>

          {/* Col 2 — Quick Links */}
          <div className={styles.col}>
            <h3 className={styles.col_heading}>Quick Links</h3>
            <ul className={styles.link_list}>
              {quickLinks.map((l, i) => (
                <li key={i}>
                  <Link to={l.to} className={styles.footer_link}>
                    <span className={styles.link_dot}></span>
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Col 3 — Services */}
          <div className={styles.col}>
            <h3 className={styles.col_heading}>Our Services</h3>
            <ul className={styles.link_list}>
              {services.map((s, i) => (
                <li key={i}>
                  <Link to={s.to} className={styles.footer_link}>
                    <span className={styles.link_dot}></span>
                    {s.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Col 4 — Contact */}
          <div className={styles.col}>
            <h3 className={styles.col_heading}>Get in Touch</h3>
            <ul className={styles.contact_list}>
              <li className={styles.contact_item}>
                <span className={styles.contact_icon}><i className='fas fa-map-marker-alt'></i></span>
                <span>Deccan, Pune — Maharashtra, India</span>
              </li>
              <li className={styles.contact_item}>
                <span className={styles.contact_icon}><i className='fas fa-phone-alt'></i></span>
                <a href='tel:+919922966739' className={styles.contact_link}>+91 99229 66739</a>
              </li>
              <li className={styles.contact_item}>
                <span className={styles.contact_icon}><i className='fas fa-envelope'></i></span>
                <a href='mailto:info@yeskondomedia.com' className={styles.contact_link}>info@yeskondomedia.com</a>
              </li>
              <li className={styles.contact_item}>
                <span className={styles.contact_icon}><i className='fas fa-clock'></i></span>
                <span>Mon – Sat: 9:00 AM – 7:00 PM</span>
              </li>
            </ul>
          </div>

        </div>
      </div>

      {/* ── Bottom Bar ── */}
      <div className={styles.footer_bottom}>
        <div className={styles.bottom_inner}>
          <p className={styles.copyright}>
            © {new Date().getFullYear()} Yeskondo Media Pvt. Ltd. — All rights reserved.
          </p>
          <p className={styles.tagline}>
            Best Marketing Company in Pune 🏆
          </p>
        </div>
      </div>

    </footer>
  );
};

export default Footer;